import { render, staticRenderFns } from "./ModalAdd.vue?vue&type=template&id=15b075ae&scoped=true&"
import script from "./ModalAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdd.vue?vue&type=style&index=0&id=15b075ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b075ae",
  null
  
)

export default component.exports